import { useEffect, useState } from 'react';
import { get } from 'lodash';
import { Controller, useForm } from 'react-hook-form';
import InputField from '../.././Common/InputField';
import CheckboxField from '../.././Common/CheckboxField';
import { Grid, Button } from '@mui/material';
import TicketCharter from '.././Ticket-Notes/TicketCharter';
import CustomModal from '../../Common/CustomModal';
import DateField from '../../Common/DateField';
import PhoneInput from 'react-phone-number-input/react-hook-form-input';
import {
  isValidPhoneNumber,
  isPossiblePhoneNumber,
} from 'react-phone-number-input';
import { putRequest, getRequest } from '.././interceptor/interceptor';
import FullScreenLoader from '.././Loader/FullScreenLoader';
import {
  UPDATE_TICKET,
  REFERRAL_DATA_BY_CONTACT,
  ASSIGNED_TO,
  TTD_DATES,
} from '../.././apiConst';
import { State, City } from 'country-state-city';
import ApplicationTabs from './ApplicationTabs';
import { useLocation, useNavigate } from 'react-router';
import SelectDropdown from '../.././Common/SelectDropdown';
import {
  grievanceStepperFields,
  referalFields,
  grievanceStepperTicketFields,
  applicantDetailsFields,
  grievanceRequestFields,
  approvalActionFields,
  followUpFields,
} from '../.././Fields/grievanceFields';
import CkEditorComponent from '../.././Common/CkEditor';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import {
  setTicketDetails,
  setTrackingStateIndex,
} from '../../redux/actions/trackingState.action';
import { FaChevronUp, FaChevronDown } from 'react-icons/fa';
import { toast } from 'react-toastify';
import BackButton from '../../Common/BackButton';
import { subDepartmentOptions } from '../../Fields/subDepartmentOptions';

const Form = ({ disabled }) => {
  console.log('disabled', disabled);
  const trackingState = useSelector((state) => state.tracking.trackingState);
  const ticketDetails = useSelector((state) => state.tracking.ticketDetails);
  const dispatch = useDispatch();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const fields = grievanceStepperFields;
  const ticketFields = grievanceStepperTicketFields;
  const [id, setId] = useState(null);
  const [isDisabledTicket, setIsDisabledTicket] = useState(false);
  const [ticketNo, setTicketNo] = useState(
    location?.state?.data?.task?.ticketNo || null
  );
  const [isEdit, setIsEdit] = useState(null);
  const [requestDetails, setRequestDetails] = useState(false);
  const [contactDetails, setContactDetails] = useState(false);
  const [detailsKnown, setDetailsKnown] = useState(false);
  const [other, setOther] = useState('');
  const [qualification, setQualification] = useState('');
  const [currentLocation, setCurrentLocation] = useState('');
  const [requestedLocation, setRequestedLocation] = useState('');
  const [referral, setReferral] = useState(false);
  const [ticket, setTicket] = useState(null);
  const [disableAllFields, setDisableAllFields] = useState(false);
  const [formStatus, setFormStatus] = useState('');
  const [assignedTo, setAssignedTo] = useState([]);
  const [assignedToValue, setAssignedToValue] = useState('');
  const [ttdDatesApproved, setTtdDatesApproved] = useState([]);
  const [ttdDatesInProgress, setTtdDatesInProgress] = useState([]);
  const [minDate, setMinDate] = useState('');
  const [followUpDisabled, setFollowUpDisabled] = useState(false);

  const [isTicketToggle, setIsTicketToggle] = useState(true); // State to toggle the accordion
  const [isApplicantToggle, setIsApplicantToggle] = useState(true); // State to toggle the accordion
  const [isRequestToggle, setIsRequestToggle] = useState(true); // State to toggle the accordion
  const [isRefferalToggle, setIsRefferalToggle] = useState(true); // State to toggle the accordion
  const [isAssignedToggle, setIsAssignedToggle] = useState(true);

  const ticketToggleAccordion = () => {
    setIsTicketToggle(!isTicketToggle);
    // setIsApplicantToggle(false);
    // setIsRequestToggle(false);
    // setIsRefferalToggle(false);
    // setIsAssignedToggle(false);
  };
  const applicantToggleAccordion = () => {
    setIsApplicantToggle(!isApplicantToggle);
    // setIsRequestToggle(false);
    // setIsRefferalToggle(false);
    // setIsTicketToggle(false);
    // setIsAssignedToggle(false);
  };
  const requestToggleAccordion = () => {
    setIsRequestToggle(!isRequestToggle);
    // setIsRefferalToggle(false);
    // setIsTicketToggle(false);
    // setIsApplicantToggle(false);
    // setIsAssignedToggle(false);
  };
  const refferalToggleAccordion = () => {
    setIsRefferalToggle(!isRefferalToggle);
    // setIsApplicantToggle(false);
    // setIsRequestToggle(false);
    // setIsTicketToggle(false);
    // setIsAssignedToggle(false);
  };

  const assignedToggleAccordion = () => {
    setIsAssignedToggle(!isAssignedToggle);
    // setIsRefferalToggle(false);
    // setIsTicketToggle(false);
    // setIsApplicantToggle(false);
    // setIsRequestToggle(false);
  };

  const [refType, setRefType] = useState('');

  const [referralType, setRefferalType] = useState([
    { label: 'Self', value: 'self' },
    { label: 'TDP Cadre', value: 'tdpCadre' },
    { label: 'Janasena Cadre', value: 'janasenaCadre' },
    { label: 'Other', value: 'other' },
  ]);
  const [priority, setPriority] = useState([
    { label: 'High', value: 'high' },
    { label: 'Low', value: 'low' },
    { label: 'Medium', value: 'medium' },
  ]);
  const [referralMode, setRefferalMode] = useState([
    { label: 'Letter', value: 'letter' },
    { label: 'Phone Call', value: 'phoneCall' },
    { label: 'Text Message', value: 'textMessage' },
    { label: 'In Person', value: 'inPerson' },
  ]);

  const [requestType, setRequestType] = useState('');
  const [requestMode, setRequestMode] = useState('');
  const [personalRequestType, setPersonalRequestType] = useState('');
  const [stateDepartment, setStateDepartment] = useState('');
  const [centralDepartment, setCentralDepartment] = useState('');
  const [ttdAvailableSlot, setTtdAvailableSlot] = useState('');
  const [medicalRequestType, setMedicalRequestType] = useState('');
  const [modal, setModal] = useState(false);
  const [communityRequestDepartment, setCommunityRequestDepartment] =
    useState('');
  const [privateRequestType, setPrivateRequestType] = useState('');
  const [employmentRequestType, setEmploymentRequestType] = useState('');

  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [village, setVillage] = useState('');
  const { role } = useSelector((state) => state.user);

  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    getValues,
    control,
    formState: { errors },
  } = useForm({});

  const { task } = location?.state?.data;

  const emailValidation = {
    validate: (value) => {
      if (!value) return true;
      const emails = value.split(/[\s,]+/);
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return (
        emails.every((email) => emailRegex.test(email)) ||
        'Please enter valid email addresses separated by commas or spaces'
      );
    },
  };

  useEffect(() => {
    if (assignedTo.length > 0) {
      setValue('assignedTo', task?.assignedTo);
      const indiaStates = State.getStatesOfCountry('IN');
      const indiaCities = City.getCitiesOfCountry('IN');
      const sortedCities = indiaCities.sort((a, b) => {
        if (a.name === 'Srikakulam') return -1;
        if (b.name === 'Srikakulam') return 1;
        return a.name.localeCompare(b.name);
      });
      setStates(indiaStates);
      setCities(sortedCities);
    }
  }, [assignedTo]);

  useEffect(() => {
    // const { task } = location?.state?.data;
    setFollowUpDisabled(task?.followup);
    console.log('task', task);

    // Set form fields using setValue
    fields.map((field) => setValue(field.fieldName, task[field.fieldName]));
    setTicketNo(task.ticketNo);
    setContactDetails(task.contactDetails);
    setDetailsKnown(task.detailsKnown);
    setReferral(task.referral);
    setRequestDetails(task.requestDetails);
    // miscellaneous
    setOther(task.miscellaneous);
    //requestType
    setRequestType(task?.requestType);
    setPrivateRequestType(task?.privateRequestType);
    // personalRequestType
    setPersonalRequestType(task.personalRequestType);
    setEmploymentRequestType(task.employmentRequestType);
    setStateDepartment(task?.stateDepartment);
    setCentralDepartment(task?.centralDepartment);
    setTtdAvailableSlot(task.ttdAvailableSlot);
    setVillage(task?.village);

    // medicalRequestType
    setMedicalRequestType(task.medicalRequest);

    // Set individual form fields
    setValue('state', task?.state);
    setValue('pincode', task?.pincode);
    setValue('applicantMobile', task?.applicantMobile);
    setValue('village', task?.village);
    setValue('applicantMiscellaneous', task?.applicantMiscellaneous);
    setValue('district', task?.district);
    setValue('constituency', task?.constituency);
    setValue('mandal', task?.mandal);
    setValue('issuePOC', task?.issuePOC);
    setValue('issueContact', task?.issueContact);
    setValue('issueDepartment', task?.issueDepartment);
    setValue('referralType', task?.referralType);
    setValue('privateRequestType', task?.privateRequestType);
    setValue('employmentRequestType', task?.employmentRequestType);
    setValue('referralContact', task?.referralContact);
    setValue('referralName', task?.referralName);
    setValue('referralDesignation', task?.referralDesignation);
    setValue('referralMode', task?.referralMode);
    setValue('requestDetails', task?.requestDetails);
    setValue('medicalRequestType', task?.medicalRequestType);
    setValue('personalRequestType', task?.personalRequestType);
    setValue(
      'ttdAvailableSlot',
      task?.ttdAvailableSlot === '' ? new Date() : task?.ttdAvailableSlot
    );
    setValue('miscellaneous', task?.miscellaneous);
    setValue('ticketStatus', task?.ticketStatus);
    setValue('stage', task?.stage);
    setValue('priority', task?.priority);
    setValue('qualification', task?.qualification);
    setValue('currentLocation', task?.currentLocation);
    setValue('requestedLocation', task?.requestedLocation);
    setValue('contactDetails', task?.contactDetails);
    setValue('detailsKnown', task?.detailsKnown);
    setValue('contactName', task?.contactName);
    setValue('contactNumber', task?.contactNumber);
    setValue('contactDesignation', task?.contactDesignation);
    setValue('hospitalName', task?.hospitalName);
    setValue('typeOfIllness', task?.typeOfIllness);
    setValue('estimateAmount', task?.estimateAmount);
    setValue('cost', task?.cost);
    setValue('grant', task?.grant);
    setValue('subDepartment', task?.subDepartment);
    setValue('requestType', task?.requestType);
    setValue('requestMode', task?.requestMode);
    setValue('staffDesignation', task?.staffDesignation);

    if (task?.requestMode === 'state') {
      setRequestMode('state');
      setValue('stateDepartment', task?.stateDepartment);
    } else if (task?.requestMode === 'central') {
      setRequestMode('central');
      setValue('centralDepartment', task?.centralDepartment);
    } else if (task?.requestMode === 'private') {
      setRequestMode('private');
    }

    if (task?.ticketStatus === 'backlog') {
      dispatch(setTrackingStateIndex(Number(0)));
    } else if (
      task?.ticketStatus === 'addressed' ||
      task?.ticketStatus === 'rejected'
    ) {
      dispatch(setTrackingStateIndex(Number(1)));
    } else {
      dispatch(setTrackingStateIndex(Number(2)));
    }
  }, []);

  useEffect(() => {
    let today = new Date();
    setMinDate(new Date(today.setDate(today.getDate() + 1)));
  }, []);

  useEffect(() => {
    getExcludedDates();
    fetchAssignedTo();
  }, []);

  const getExcludedDates = () => {
    let url = '';
    url = getRequest(`${TTD_DATES}`);
    url
      .then((res) => {
        setTtdDatesApproved(res.approved);
        setTtdDatesInProgress(res.inprogress);
      })
      .catch((error) => {
        console.log('error ttd', error);
      });
  };

  const fetchAssignedTo = async () => {
    await getRequest(`${ASSIGNED_TO}`).then((res) => {
      if (res) {
        console.log('🚀 ~ awaitgetRequest ~ es:', res);
        const options = [];
        res.forEach((item, index) => {
          options.push({
            label: item?.email,
            value: item?.email,
          });
        });
        setAssignedTo(options);
      }
    });
  };

  const onSubmit = async (data, e) => {
    let referalNumber = data?.referralContact;

    let ccEmails = [];
    if (data?.ccEmail) {
      ccEmails = data.ccEmail
        .split(/[\s,]+/) // split by comma or whitespace
        .map((email) => email.trim()) // trim whitespace
        .filter((email) => email.length > 0); // remove empty strings if any
    }

    console.log('referalNumber', referalNumber);

    if (referalNumber) {
      const isReferralContact = isValidPhoneNumber(referalNumber);

      if (!isReferralContact) {
        setIsLoading(false);
        return toast.error('Enter a valid referral phone number!');
      }
    }

    setIsLoading(true);

    // if (data?.assignedTo === '') {
    //   setIsLoading(false);
    //   return toast.error('Assigned to is required!');
    // }

    // if (data?.priority === '') {
    //   setIsLoading(false);
    //   return toast.error('Priority is required!');
    // }

    if (e.target.value === 'addressed') {
      data = {
        ...data,
        ccEmail: ccEmails,
        isDraft: false,
        isStepperForm: true,
        requestType: requestType,
        privateRequestType: privateRequestType,
        assignedTo: data?.assignedTo,
        priority: data?.priority,
        ticketStatus: 'addressed',
        ttdAvailableSlot:
          data?.personalRequestType !== 'TTD Darshan'
            ? ''
            : data?.ttdAvailableSlot,
      };
      let url = '';
      url = await putRequest(`${UPDATE_TICKET}`, data);

      try {
        toast.success(url?.data?.message);
        if (url?.data?.message) {
          setIsLoading(false);
          navigate('/gms');
        } else {
          setIsLoading(false);
        }
      } catch (error) {
        setIsLoading(false);
        console.log('🚀 ~ onSubmit ~ error:', error);
      }

      setIsLoading(false);
    } else if (e.target.value === 'rejected') {
      data = {
        ...data,
        ccEmail: ccEmails,
        isDraft: false,
        isStepperForm: true,
        requestType: requestType,
        privateRequestType: privateRequestType,
        assignedTo: data?.assignedTo,
        priority: data?.priority,
        ticketStatus: 'rejected',
        ttdAvailableSlot:
          data?.personalRequestType !== 'TTD Darshan'
            ? ''
            : data?.ttdAvailableSlot,
      };
      let url = '';
      url = await putRequest(`${UPDATE_TICKET}`, data);
      try {
        toast.success(url?.data?.message);
        if (url?.data?.message) {
          setIsLoading(false);
          navigate('/gms');
        } else {
          setIsLoading(false);
        }
      } catch (error) {
        setIsLoading(false);
        console.log('🚀 ~ onSubmit ~ error:', error);
      }
      setIsLoading(false);
    } else if (e.target.value === 'resolved') {
      data = {
        ...data,
        ccEmail: ccEmails,
        isDraft: false,
        isStepperForm: true,
        requestType: requestType,
        privateRequestType: privateRequestType,
        assignedTo: data?.assignedTo,
        priority: data?.priority,
        ticketStatus: 'resolved',
        ttdAvailableSlot:
          data?.personalRequestType !== 'TTD Darshan'
            ? ''
            : data?.ttdAvailableSlot,
      };
      let url = '';
      url = await putRequest(`${UPDATE_TICKET}`, data);
      try {
        toast.success(url?.data?.message);
        if (url?.data?.message) {
          setIsLoading(false);
          navigate('/gms');
        } else {
          setIsLoading(false);
        }
      } catch (error) {
        setIsLoading(false);
        console.log('🚀 ~ onSubmit ~ error:', error);
      }
      setIsLoading(false);
    } else if (e.target.value === 'submit') {
      data = {
        ...data,
        ccEmail: ccEmails,
        isDraft: false,
        isStepperForm: true,
        requestType: requestType,
        privateRequestType: privateRequestType,
        assignedTo: data?.assignedTo,
        priority: data?.priority,
        ticketStatus: 'backlog',
        ttdAvailableSlot:
          data?.personalRequestType !== 'TTD Darshan'
            ? ''
            : data?.ttdAvailableSlot,
      };
      let url = '';
      url = await putRequest(`${UPDATE_TICKET}`, data);
      try {
        toast.success(url?.data?.message);
        if (url?.data?.message) {
          setIsLoading(false);
          navigate('/gms');
        } else {
          setIsLoading(false);
        }
      } catch (error) {
        setIsLoading(false);
        console.log('🚀 ~ onSubmit ~ error:', error);
      }
      setIsLoading(false);
    } else if (e.target.value === 'followUp') {
      setFollowUpDisabled(true);
      data = {
        ...data,
        ccEmail: ccEmails,
        isDraft: false,
        isStepperForm: true,
        requestType: requestType,
        privateRequestType: privateRequestType,
        assignedTo: data?.assignedTo,
        priority: data?.priority,
        ttdAvailableSlot:
          data?.personalRequestType !== 'TTD Darshan'
            ? ''
            : data?.ttdAvailableSlot,
        followup: true,
        followupData: {
          date: data.followUpDate,
          comment: data.followUpNote,
          email: data.followUpEmail,
        },
      };
      delete data.followUpDate;
      delete data.followUpNote;
      delete data.followUpEmail;
      let url = '';
      url = await putRequest(`${UPDATE_TICKET}`, data);
      try {
        toast.success(url?.data?.message);
        if (url?.data?.message) {
          setIsLoading(false);
          setModal(false);
        } else {
          setIsLoading(false);
        }
      } catch (error) {
        setIsLoading(false);
        console.log('🚀 ~ onSubmit ~ error:', error);
      }
      // url
      //   .then((res) => {
      //     setIsLoading(false);
      //     setModal(false);
      //   })
      //   .catch(() => {
      //     setIsLoading(false);
      //   });
      setIsLoading(false);
    } else {
      data = {
        ...data,
        ccEmail: ccEmails,
        isDraft: true,
        isStepperForm: true,
        requestType: requestType,
        privateRequestType: privateRequestType,
        assignedTo: data?.assignedTo,
        priority: data?.priority,
        ticketStatus: task?.ticketStatus,
        ttdAvailableSlot:
          data?.personalRequestType !== 'TTD Darshan'
            ? ''
            : data?.ttdAvailableSlot,
      };
      let url = '';
      url = await putRequest(`${UPDATE_TICKET}`, data);
      try {
        toast.success(url?.data?.message);
        if (url?.data?.message) {
          setIsLoading(false);
          navigate('/gms');
        } else {
          setIsLoading(false);
        }
      } catch (error) {
        setIsLoading(false);
        console.log('🚀 ~ onSubmit ~ error:', error);
      }
      setIsLoading(false);
    }
    setIsLoading(false);
  };

  const conditionalFields = [
    {
      fieldName: 'personalRequestType',
      fieldTitle: 'Personal Request Type*',
      // validationObj: {
      //   required: 'Please Select Request Type',
      // },
      fieldType: 'select',
      options: [
        {
          label: 'Employment Request',
          value: 'Employment Request',
        },
        {
          label: 'Transfer Request',
          value: 'Transfer Request',
        },
        {
          label: 'TTD Darshan',
          value: 'TTD Darshan',
        },
        {
          label: 'Other',
          value: 'other',
        },
      ], // Populate with request type options
    },
    {
      fieldName: 'stateDepartment',
      fieldTitle: 'Department*',
      // validationObj: {
      //   required: 'Please Select Department',
      // },
      fieldType: 'select',
      options: [
        { label: 'Collectorate', value: 'Collectorate' },
        { label: 'Judiciary', value: 'Judiciary' },
        { label: 'Revenue', value: 'Revenue' },
        { label: 'Judiciary', value: 'Judiciary' },
        { label: 'Housing', value: 'Housing' },
        { label: 'Panchayat Raj', value: 'Panchayat Raj' },
        { label: 'Roads & Buildings', value: 'Roads & Buildings' },
        { label: 'Agriculture', value: 'Agriculture' },
        { label: 'Police', value: 'Police' },
        { label: 'Fisheries', value: 'Fisheries' },
        { label: 'Forest', value: 'Forest' },
        { label: 'Health', value: 'Health' },
        { label: 'Education', value: 'Education' },
        { label: 'Irrigation', value: 'Irrigation' },
        { label: 'Endowment', value: 'Endowment' },
        { label: 'Rural Water Supply', value: 'Rural Water Supply' },
        { label: 'Municipal Corporation', value: 'Municipal Corporation' },
        { label: 'Zilla Parishad', value: 'Zilla Parishad' },
        { label: 'Tribal Welfare', value: 'Tribal Welfare' },
        { label: 'DRDA', value: 'DRDA' },
        { label: 'DWMA', value: 'DWMA' },
        { label: 'Planning', value: 'Planning' },
        { label: 'Transport', value: 'Transport' },
        { label: 'Pollution Control Board', value: 'Pollution Control Board' },
        { label: 'Civil Supplies', value: 'Civil Supplies' },
        { label: 'Animal Husbandry', value: 'Animal Husbandry' },
        { label: 'Horticulture', value: 'Horticulture' },
        { label: 'Tourism', value: 'Tourism' },
        { label: 'Electrical', value: 'Electrical' },
        { label: 'Women and Child Welfare', value: 'Women and Child Welfare' },
        {
          label: 'Social Welfare (SC,ST,BC)',
          value: 'Social Welfare (SC,ST,BC)',
        },
        {
          label: 'Industry & Commerce Department',
          value: 'Industry & Commerce Department',
        },
      ], // Populate with request type options
    },
    {
      fieldName: 'medicalRequestType',
      fieldTitle: 'Medical Request Type*',
      // validationObj: {
      //   required: 'Please Select Request Type',
      // },
      fieldType: 'select',
      options: [
        {
          label: 'CMRF',
          value: 'CMRF',
        },
        {
          label: 'PMRF',
          value: 'PMRF',
        },
        {
          label: 'Medical Aid',
          value: 'Medical Aid',
        },
      ], // Populate with request type options
    },
    {
      fieldName: 'ttdAvailableSlot',
      fieldTitle: 'TTD Available Slot*',
      fieldType: 'date',
    },
    {
      fieldName: 'miscellaneous',
      fieldTitle: 'Miscellaneous*',
      fieldType: 'text',
    },
    {
      fieldName: 'qualification',
      fieldTitle: 'Qualification*',
      fieldType: 'text',
    },
    {
      fieldName: 'department',
      fieldTitle: 'Department*',
      fieldType: 'text',
    },
    {
      fieldName: 'currentLocation',
      fieldTitle: 'Current Location*',
      fieldType: 'text',
    },
    {
      fieldName: 'requestedLocation',
      fieldTitle: 'Requested Location*',
      fieldType: 'text',
    },
    {
      fieldName: 'centralDepartment',
      fieldTitle: 'Department*',
      // validationObj: {
      //   required: 'Please Select Department',
      // },
      fieldType: 'select',
      options: [
        {
          label: "Agriculture & Farmers' Welfare",
          value: "Agriculture & Farmers' Welfare",
        },
        {
          label: 'Animal Husbandry, Dairying & Fisheries',
          value: 'Animal Husbandry, Dairying & Fisheries',
        },
        { label: 'AYUSH', value: 'AYUSH' },
        { label: 'Chemicals & Fertilizers', value: 'Chemicals & Fertilizers' },
        { label: 'Civil Aviation', value: 'Civil Aviation' },
        { label: 'Coal', value: 'Coal' },
        { label: 'Commerce & Industry', value: 'Commerce & Industry' },
        { label: 'Communications', value: 'Communications' },
        {
          label: 'Consumer Affairs, Food & Public Distribution',
          value: 'Consumer Affairs, Food & Public Distribution',
        },
        { label: 'Co-operation', value: 'Co-operation' },
        { label: 'Corporate Affairs', value: 'Corporate Affairs' },
        { label: 'Culture', value: 'Culture' },
        { label: 'Defence', value: 'Defence' },
        {
          label: 'Development of North Eastern Region',
          value: 'Development of North Eastern Region',
        },
        { label: 'Earth Sciences', value: 'Earth Sciences' },
        { label: 'Education', value: 'Education' },
        {
          label: 'Electronics & Information Technology',
          value: 'Electronics & Information Technology',
        },
        {
          label: 'Environment, Forests & Climate Change',
          value: 'Environment, Forests & Climate Change',
        },
        { label: 'External Affairs', value: 'External Affairs' },
        { label: 'Finance', value: 'Finance' },
        {
          label: 'Food Processing Industries',
          value: 'Food Processing Industries',
        },
        { label: 'Health & Family Welfare', value: 'Health & Family Welfare' },
        { label: 'Heavy Industries', value: 'Heavy Industries' },
        { label: 'Home Affairs', value: 'Home Affairs' },
        { label: 'Housing & Urban Affairs', value: 'Housing & Urban Affairs' },
        {
          label: 'Information & Broadcasting',
          value: 'Information & Broadcasting',
        },
        { label: 'Jal Shakti', value: 'Jal Shakti' },
        { label: 'Labour & Employment', value: 'Labour & Employment' },
        { label: 'Law & Justice', value: 'Law & Justice' },
        {
          label: 'Micro, Small & Medium Enterprises',
          value: 'Micro, Small & Medium Enterprises',
        },
        { label: 'Mines', value: 'Mines' },
        { label: 'Minority Affairs', value: 'Minority Affairs' },
        { label: 'New & Renewable Energy', value: 'New & Renewable Energy' },
        { label: 'Panchayati Raj', value: 'Panchayati Raj' },
        { label: 'Parliamentary Affairs', value: 'Parliamentary Affairs' },
        {
          label: 'Personnel, Public Grievances & Pensions',
          value: 'Personnel, Public Grievances & Pensions',
        },
        { label: 'Petroleum & Natural Gas', value: 'Petroleum & Natural Gas' },
        { label: 'Planning', value: 'Planning' },
        {
          label: 'Ports, Shipping & Waterways',
          value: 'Ports, Shipping & Waterways',
        },
        { label: 'Power', value: 'Power' },
        { label: "Prime Minister's Office", value: "Prime Minister's Office" },
        { label: 'Rural Development', value: 'Rural Development' },
        {
          label: 'Road Transport & Highways',
          value: 'Road Transport & Highways',
        },
        { label: 'Railways', value: 'Railways' },
        { label: 'Science & Technology', value: 'Science & Technology' },
        {
          label: 'Skill Development & Entrepreneurship',
          value: 'Skill Development & Entrepreneurship',
        },
        {
          label: 'Social Justice & Empowerment',
          value: 'Social Justice & Empowerment',
        },
        {
          label: 'Statistics & Programme Implementation',
          value: 'Statistics & Programme Implementation',
        },
        { label: 'Steel', value: 'Steel' },
        { label: 'Textiles', value: 'Textiles' },
        { label: 'Tourism', value: 'Tourism' },
        { label: 'Tribal Affairs', value: 'Tribal Affairs' },
        {
          label: 'Women & Child Development',
          value: 'Women & Child Development',
        },
        { label: 'Youth Affairs & Sports', value: 'Youth Affairs & Sports' },
      ], // Populate with request type options
    },
    {
      fieldName: 'contactDetails',
      fieldTitle: 'Contact Details',
      fieldType: 'checkbox', // This seems like a checkbox based on the image
    },
    {
      fieldName: 'detailsKnown',
      fieldTitle: 'Details Known',
      fieldType: 'checkbox', // This seems like a checkbox based on the image
    },
    {
      fieldName: 'subDepartment',
      fieldTitle: 'Sub Department',
      fieldType: 'select',
      options: subDepartmentOptions,
    },
    {
      fieldName: 'requestType',
      fieldTitle: 'Request Type*',
      fieldType: 'select',
      options: [
        { label: 'Personal', value: 'personal' },
        { label: 'Community', value: 'community' },
        { label: 'Official', value: 'official' },
        { label: 'Medical', value: 'medical' },
        { label: 'Other', value: 'other' },
      ],
    },
    {
      fieldName: 'privateRequestType',
      fieldTitle: 'Request Type*',
      fieldType: 'select',
      options: [
        {
          label: 'Employment',
          value: 'Employment',
        },
        {
          label: 'Help/Assistance',
          value: 'Help/Assistance',
        },
        {
          label: 'Other',
          value: 'other',
        },
      ],
    },
    {
      fieldName: 'employmentRequestType',
      fieldTitle: 'Employment Request Type*',
      fieldType: 'select',
      options: [
        {
          label: 'New Job',
          value: 'New Job',
        },
        {
          label: 'Role Change',
          value: 'Role Change',
        },
        {
          label: 'Transfer',
          value: 'Transfer',
        },
        {
          label: 'Other',
          value: 'other',
        },
      ],
    },
  ];

  const transferContactDetails = [
    {
      fieldTitle: 'Contact Name',
      fieldName: 'contactName',
      fieldType: 'text',
    },
    {
      fieldTitle: 'Contact Number',
      fieldName: 'contactNumber',
      fieldType: 'text',
    },
    {
      fieldTitle: 'Contact Designation',
      fieldName: 'contactDesignation',
      fieldType: 'text',
    },
  ];

  const communityContactDetails = [
    {
      fieldTitle: 'Cost',
      fieldName: 'cost',
      fieldType: 'text',
    },
    {
      fieldTitle: 'Grant',
      fieldName: 'grant',
      fieldType: 'text',
    },
    {
      fieldTitle: 'Contact Name',
      fieldName: 'contactName',
      fieldType: 'text',
    },
    {
      fieldTitle: 'Contact Number',
      fieldName: 'contactNumber',
      fieldType: 'text',
    },
  ];

  const officialContactDetails = [
    {
      fieldTitle: 'Contact Name',
      fieldName: 'contactName',
      fieldType: 'text',
    },
    {
      fieldTitle: 'Contact Number',
      fieldName: 'contactNumber',
      fieldType: 'text',
    },
  ];

  const medicalDetails = [
    {
      fieldTitle: 'Hospital Name',
      fieldName: 'hospitalName',
      fieldType: 'text',
    },
    {
      fieldTitle: 'Type Of Illness',
      fieldName: 'typeOfIllness',
      fieldType: 'text',
    },
    {
      fieldTitle: 'Estimate Amount',
      fieldName: 'estimateAmount',
      fieldType: 'text',
    },
  ];

  const centralPersonalOptions = [
    [
      {
        label: 'Employment Request',
        value: 'Employment Request',
      },
      {
        label: 'Transfer Request',
        value: 'Transfer Request',
      },
      {
        label: 'Other',
        value: 'other',
      },
    ], // Populate with request type options
  ];

  const pressCloseButton = () => {
    // reset();
    setModal(!modal);
  };
  const handleOpenModal = () => {
    // reset({followUpEmail:'',followUpNote:""})
    setModal(!modal);
  };

  const submitBtns = () => {
    if (role === 'editor' && trackingState !== 3) {
      return (
        <div className="flex flex-col lg:flex-row items-center justify-start space-x-4 mb-4">
          <Grid item>
            <Button
              variant="contained"
              color="secondary"
              value="save"
              onClick={handleSubmit(onSubmit)}
              className="mt-5"
            >
              Save
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              // color="primary"
              value="submit"
              onClick={handleSubmit(onSubmit)}
              className="mt-5 bg-blueBg hover:blueBg"
            >
              Submit
            </Button>
          </Grid>
        </div>
      );
    }

    return (
      <div className="flex flex-col lg:flex-row items-center justify-start space-x-4 mb-4">
        {trackingState === 0 ? (
          <>
            <Grid item>
              <Button
                variant="contained"
                color="secondary"
                value="save"
                onClick={handleSubmit(onSubmit)}
                className="mt-5"
              >
                Save
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                // color="primary"
                value="submit"
                onClick={handleSubmit(onSubmit)}
                className="mt-5 bg-blueBg hover:blueBg"
              >
                Submit
              </Button>
            </Grid>
          </>
        ) : trackingState === 1 ? (
          <>
            <Grid item>
              <Button
                variant="contained"
                color="secondary"
                value="save"
                onClick={handleSubmit(onSubmit)}
                className="mt-5"
              >
                Save
              </Button>
            </Grid>
            <Grid item>
              <Button
                type="submit"
                variant="contained"
                // color="primary"
                className="mt-5 bg-blueBg hover:blueBg"
                value="addressed"
                onClick={handleSubmit(onSubmit)}
              >
                Approve
              </Button>
            </Grid>
            <Grid item>
              <Button
                type="submit"
                variant="contained"
                color="error"
                className="mt-5"
                value="rejected"
                onClick={handleSubmit(onSubmit)}
              >
                Reject
              </Button>
            </Grid>
            <Grid item>
              <Button
                type="submit"
                variant="contained"
                color="success"
                className="mt-5"
                value="resolved"
                onClick={handleSubmit(onSubmit)}
              >
                Mark As Resolved
              </Button>
            </Grid>
          </>
        ) : trackingState === 2 && task?.ticketStatus === 'addressed' ? (
          <>
            <Grid item>
              <Button
                type="submit"
                variant="contained"
                color="success"
                className="mt-5"
                value="resolved"
                onClick={handleSubmit(onSubmit)}
              >
                Mark As Resolved
              </Button>
            </Grid>
            <Grid item>
              <Button
                type="submit"
                variant="contained"
                // color="primary"
                className="mt-5 bg-blueBg hover:blueBg"
                value="submit"
                onClick={handleSubmit(onSubmit)}
              >
                Re-Open
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                color="secondary"
                className="mt-5"
                value="followUp"
                onClick={handleOpenModal}
                disabled={followUpDisabled}
              >
                Follow-Up
              </Button>
            </Grid>
          </>
        ) : trackingState === 2 && task?.ticketStatus === 'rejected' ? (
          <Grid item>
            <Button
              type="submit"
              variant="contained"
              // color="primary"
              className="mt-5 bg-blueBg hover:blueBg"
              value="submit"
              onClick={handleSubmit(onSubmit)}
            >
              Re-Open
            </Button>
          </Grid>
        ) : null}
      </div>
    );
  };

  const fetchReferralDetails = (contactNumber) => {
    setIsLoading(true);
    setIsLoading(true);
    getRequest(`${REFERRAL_DATA_BY_CONTACT}${contactNumber}`)
      .then((res) => {
        if (res) {
          // Assuming the API response contains `referralName` and `referralDesignation`
          setValue('referralName', res.referralName || '');
          setValue('referralDesignation', res.referralDesignation || '');
          setValue('referralMode', res.referralMode || '');
          setValue('referralType', res.referralType || '');
          setIsLoading(false);
        } else {
          setIsLoading(true);
        }
      })
      .catch(() => {
        setIsLoading(false);
      });
  };

  const handleBlur = (e) => {
    const contactNumber = '+91' + e.target.value.replace(/[^\d\+]/g, '');
    if (refType !== 'self' && contactNumber) {
      fetchReferralDetails(contactNumber);
    }
  };

  const ModalBody = () => {
    return (
      <>
        {isLoading && <FullScreenLoader />}
        <form className="w-full flex justify-center items-center flex-col p-5">
          <div className="w-full grid md:grid-cols-1 gap-6">
            {followUpFields?.map((field) => {
              const {
                fieldTitle,
                fieldName,
                fieldType,
                validationObj,
                disabled,
              } = field;
              return (
                <div className="flex flex-col w-full" key={fieldName}>
                  <label className="block text-gray-800 font-bold pr-4">
                    {fieldTitle}
                  </label>
                  <div className="w-full flex items-center">
                    <div className="w-full">
                      {fieldType === 'date' ? (
                        <>
                          <DateField
                            fieldName={fieldName}
                            validationObj={validationObj}
                            control={control}
                            Controller={Controller}
                            minDate={minDate}
                            errors={errors}
                            defaultValue={minDate}
                          />
                        </>
                      ) : (
                        <InputField
                          fieldName={fieldName}
                          validationObj={validationObj}
                          register={register}
                          errors={errors}
                          fieldType={fieldType}
                          disabled={disabled}
                          placeholder={fieldTitle}
                          className="border border-gray-300 rounded-md p-2 w-full focus:outline-none focus:ring focus:ring-primary-300"
                        />
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
            <div className="flex justify-center">
              <Button
                type="button"
                variant="contained"
                color="error"
                className="mt-4 px-6 py-2 rounded-md mr-2 text-white transition duration-150"
                onClick={pressCloseButton}
              >
                Cancel
              </Button>
              <Button
                type="button"
                variant="contained"
                color="primary"
                value="followUp"
                className="mt-4 px-6 py-2 rounded-md ml-2 text-white transition duration-150 "
                onClick={handleSubmit(onSubmit)}
              >
                Submit
              </Button>
            </div>
          </div>
        </form>
      </>
    );
  };
  const capitalizeWords = (text) =>
    text
      .toLowerCase()
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');

  return (
    <>
      <CustomModal
        modal={modal}
        body={<ModalBody />}
        heading="Follow-Up"
        pressCloseButton={pressCloseButton}
      />
      {/* {isLoading && <FullScreenLoader />} */}
      <div className="block rounded-lg bg-white p-2 lg:pt-2 lg:pb-2 lg:pl-24 lg:pr-24 shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)] m-4 overflow-auto">
        <div className="flex mb-2 text-xl font-extrabold text-primary-600">
          <BackButton onClick={() => navigate(-1)} />
        </div>
        {task?.ticketStatus === 'addressed' ||
        task?.ticketStatus === 'rejected' ? (
          <h2 className="mt-2 mb-1">
            Status:{' '}
            <h2
              className={`color: ${
                task?.ticketStatus === 'addressed'
                  ? 'text-green-500'
                  : 'text-red-500'
              } capitalize inline-block`}
            >
              {task?.ticketStatus}
            </h2>
          </h2>
        ) : null}
        {
          <h2 className="pb-0 mb-1">
            Request Title:{' '}
            <h2 className="text-blue-800 capitalize inline-block">
              {capitalizeWords(task?.requestTitle)}
            </h2>
          </h2>
        }
        <form onSubmit={handleSubmit(onSubmit)}>
          {!location?.state?.isView ? submitBtns() : null}
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <div
                className="flex justify-between items-center text-white rounded-md bg-gray-700 p-2 mb-1 cursor-pointer"
                onClick={ticketToggleAccordion} // Toggle on click
              >
                <h2>Request Information</h2>
                {/* Render the icon based on the toggle state */}
                {isTicketToggle ? <FaChevronUp /> : <FaChevronDown />}
              </div>
            </Grid>
            {isTicketToggle &&
              ticketFields.map((field) => {
                const {
                  fieldTitle,
                  fieldName,
                  fieldType,
                  validationObj,
                  options,
                } = field;

                return (
                  <Grid item xs={12} lg={3} key={fieldName}>
                    {fieldType === 'date' ? (
                      <>
                        <label className="block text-sm text-gray-800 font-bold pr-4">
                          {fieldTitle}
                        </label>
                        <DateField
                          fieldName={fieldName}
                          validationObj={validationObj}
                          control={control}
                          Controller={Controller}
                          minDate={new Date()}
                          errors={errors}
                          defaultValue={getValues(fieldName)}
                          disabled={
                            fieldName === 'issueOpen'
                              ? true
                              : task?.ticketStatus === 'rejected'
                              ? true
                              : location?.state?.isView || disabled
                          }
                        />
                      </>
                    ) : (
                      <>
                        <label className="block text-sm text-gray-800 font-bold  pr-4">
                          {fieldTitle}
                        </label>
                        <InputField
                          fieldName={fieldName}
                          validationObj={validationObj}
                          register={register}
                          disabled={
                            fieldName === 'ticketNo'
                              ? true
                              : task?.ticketStatus === 'rejected'
                              ? true
                              : location?.state?.isView || disabled
                          }
                          errors={errors}
                          fieldType={fieldType}
                        />
                      </>
                    )}
                  </Grid>
                );
              })}
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <div
                className="flex justify-between items-center text-white rounded-md bg-gray-700 p-2 mb-1 cursor-pointer"
                onClick={applicantToggleAccordion} // Toggle on click
              >
                <h2>Applicant Information</h2>
                {/* Render the icon based on the toggle state */}
                {isApplicantToggle ? <FaChevronUp /> : <FaChevronDown />}
              </div>
            </Grid>
            <>
              {isApplicantToggle &&
                applicantDetailsFields.map((field) => {
                  const {
                    fieldTitle,
                    fieldName,
                    fieldType,
                    validationObj,
                    options,
                  } = field;

                  return (
                    <Grid item xs={12} lg={3} key={fieldName}>
                      {fieldType === 'date' ? (
                        <>
                          <label className="block text-sm text-gray-800 font-bold pr-4">
                            {fieldTitle}
                          </label>
                          <DateField
                            fieldName={fieldName}
                            validationObj={validationObj}
                            control={control}
                            Controller={Controller}
                            minDate={new Date()}
                            errors={errors}
                            defaultValue={getValues(fieldName)}
                            disabled={true}
                          />
                        </>
                      ) : (
                        <>
                          <label className="block text-sm text-gray-800 font-bold pr-4">
                            {fieldTitle}
                          </label>
                          <InputField
                            fieldName={fieldName}
                            validationObj={validationObj}
                            register={register}
                            disabled={true}
                            errors={errors}
                            fieldType={fieldType}
                          />
                        </>
                      )}
                    </Grid>
                  );
                })}
              {isApplicantToggle && village === 'other' ? (
                <Grid item xs={12} lg={3}>
                  <label className="block text-sm text-gray-800 font-bold pr-4">
                    Miscellaneous
                  </label>
                  <InputField
                    fieldName="applicantMiscellaneous"
                    register={register}
                    disabled={location?.state?.isView}
                    errors={errors}
                    fieldType="text"
                  />
                </Grid>
              ) : null}
            </>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <div
                className="flex justify-between items-center text-white rounded-md bg-gray-700 p-2 mb-1 cursor-pointer"
                onClick={requestToggleAccordion} // Toggle on click
              >
                <h2> Request Details</h2>
                {/* Render the icon based on the toggle state */}
                {isRequestToggle ? <FaChevronUp /> : <FaChevronDown />}
              </div>
            </Grid>

            <>
              {isRequestToggle &&
                grievanceRequestFields
                  .filter((field) => field.fieldName === 'requestDescription')
                  .map((field) => {
                    const { fieldTitle, fieldName, fieldType, validationObj } =
                      field;

                    return (
                      <Grid item xs={12} key={fieldName}>
                        <label className="block text-sm text-gray-800 font-bold  pr-4">
                          {fieldTitle}
                        </label>
                        <InputField
                          fieldName={fieldName}
                          validationObj={validationObj}
                          register={register}
                          errors={errors}
                          fieldType={fieldType}
                          val={getValues(fieldName)}
                          disabled={
                            task?.ticketStatus === 'rejected'
                              ? true
                              : location?.state?.isView || disabled
                          }
                        />
                      </Grid>
                    );
                  })}
            </>

            {isRequestToggle &&
              grievanceRequestFields
                .filter(
                  (field) =>
                    field.fieldName !== 'additionalInformation' &&
                    field.fieldName !== 'requestDescription'
                )
                .map((field) => {
                  const {
                    fieldTitle,
                    fieldName,
                    fieldType,
                    validationObj,
                    options,
                  } = field;

                  return (
                    <Grid item xs={12} lg={3} key={fieldName}>
                      {fieldType === 'date' ? (
                        <>
                          <label className="block text-sm text-gray-800 font-bold  pr-4">
                            {fieldTitle}
                          </label>
                          <DateField
                            fieldName={fieldName}
                            validationObj={validationObj}
                            control={control}
                            Controller={Controller}
                            minDate={new Date()}
                            errors={errors}
                            defaultValue={getValues(fieldName)}
                            disabled={
                              task?.ticketStatus === 'rejected'
                                ? true
                                : location?.state?.isView || disabled
                            }
                          />
                        </>
                      ) : fieldType === 'editor' ? (
                        <>
                          <label className="block text-sm text-gray-800 font-bold  pr-4">
                            {fieldTitle}
                          </label>
                          <CkEditorComponent
                            register={register}
                            fieldName={fieldName}
                            control={control}
                            data={getValues(fieldName) || ''}
                            setValue={setValue}
                            disabled={
                              task?.ticketStatus === 'rejected'
                                ? true
                                : location?.state?.isView || disabled
                            }
                          />
                        </>
                      ) : fieldType === 'select' ? (
                        fieldName === 'requestMode' ? (
                          <>
                            <label className="block text-sm text-gray-800 font-bold  pr-4">
                              {fieldTitle}
                            </label>
                            <SelectDropdown
                              fieldName={fieldName}
                              options={options}
                              register={register}
                              // validationObj={{
                              //   required: 'Please Select Request Mode',
                              // }}
                              onChange={(e) => setRequestMode(e.target.value)}
                              errors={errors}
                              val={getValues(fieldName)}
                              disabled={
                                task?.ticketStatus === 'rejected'
                                  ? true
                                  : location?.state?.isView || disabled
                              }
                            />
                          </>
                        ) : null
                      ) : (
                        <>
                          <label className="block text-sm text-gray-800 font-bold  pr-4">
                            {fieldTitle}
                          </label>
                          <InputField
                            fieldName={fieldName}
                            validationObj={validationObj}
                            register={register}
                            disabled={
                              task?.ticketStatus === 'rejected'
                                ? true
                                : location?.state?.isView || disabled
                            }
                            errors={errors}
                            fieldType={fieldType}
                          />
                        </>
                      )}
                    </Grid>
                  );
                })}
            {isRequestToggle && (
              <>
                <>
                  <Grid item xs={12} lg={3}>
                    <label className="block text-sm text-gray-800 font-bold pr-4">
                      {conditionalFields[13].fieldTitle}
                    </label>
                    <SelectDropdown
                      fieldName={
                        requestMode === 'private'
                          ? conditionalFields[14]?.fieldName
                          : conditionalFields[13]?.fieldName
                      }
                      options={
                        requestMode === 'private'
                          ? conditionalFields[14]?.options
                          : conditionalFields[13]?.options
                      }
                      register={register}
                      // validationObj={{
                      //   required: 'Please Select Request Type',
                      // }}
                      errors={errors}
                      onChange={(e) => {
                        if (requestMode === 'private') {
                          setPrivateRequestType(e.target.value);
                          setRequestType('');
                        } else {
                          setRequestType(e.target.value);
                          setPrivateRequestType('');
                        }
                      }}
                      val={
                        requestMode === 'private'
                          ? getValues(conditionalFields[14]?.fieldName)
                          : getValues(conditionalFields[13]?.fieldName)
                      }
                      disabled={
                        task?.ticketStatus === 'rejected'
                          ? true
                          : location?.state?.isView || disabled
                      }
                    />
                  </Grid>
                  {requestMode === 'private' &&
                    privateRequestType === 'Employment' && (
                      <Grid item xs={12} lg={3}>
                        <label className="block text-sm text-gray-800 font-bold pr-4">
                          {conditionalFields[15].fieldTitle}
                        </label>
                        <SelectDropdown
                          fieldName={conditionalFields[15].fieldName}
                          options={conditionalFields[15].options}
                          register={register}
                          // validationObj={{
                          //   required: 'Please Select Request Type',
                          // }}
                          onChange={(e) => {
                            setEmploymentRequestType(e.target.value);
                          }}
                          errors={errors}
                          val={getValues(conditionalFields[15].fieldName)}
                          disabled={
                            task?.ticketStatus === 'rejected'
                              ? true
                              : location?.state?.isView || disabled
                          }
                        />
                      </Grid>
                    )}
                  {requestMode === 'state' && requestType === 'personal' && (
                    <Grid item xs={12} lg={3}>
                      <label className="block text-sm text-gray-800 font-bold  pr-4">
                        {conditionalFields[0].fieldTitle}
                      </label>
                      <SelectDropdown
                        fieldName={conditionalFields[0].fieldName}
                        options={conditionalFields[0]?.options}
                        register={register}
                        validationObj={{
                          required: 'Please Select Request Type',
                        }}
                        errors={errors}
                        onChange={(e) => setPersonalRequestType(e.target.value)}
                        val={getValues(conditionalFields[0].fieldName)}
                        disabled={
                          task?.ticketStatus === 'rejected'
                            ? true
                            : location?.state?.isView || disabled
                        }
                      />
                    </Grid>
                  )}
                  {requestMode === 'central' && requestType === 'personal' && (
                    <Grid item xs={12} lg={3}>
                      <label className="block text-sm text-gray-800 font-bold pr-4">
                        {conditionalFields[0].fieldTitle}
                      </label>
                      <SelectDropdown
                        fieldName={conditionalFields[0].fieldName}
                        options={centralPersonalOptions}
                        register={register}
                        // validationObj={{
                        //   required: 'Please Select Request Type',
                        // }}
                        errors={errors}
                        onChange={(e) => setPersonalRequestType(e.target.value)}
                        val={getValues(conditionalFields[0].fieldName)}
                        disabled={
                          task?.ticketStatus === 'rejected'
                            ? true
                            : location?.state?.isView || disabled
                        }
                      />
                    </Grid>
                  )}
                  {requestType === 'personal' &&
                    personalRequestType === 'TTD Darshan' && (
                      <Grid item xs={12} lg={3}>
                        <>
                          <label className="block text-sm text-gray-800 font-bold  pr-4">
                            {conditionalFields[3].fieldTitle}
                          </label>
                          <DateField
                            fieldName={conditionalFields[3].fieldName}
                            validationObj={conditionalFields[3].validationObj}
                            control={control}
                            Controller={Controller}
                            minDate={new Date()}
                            disabled={
                              task?.ticketStatus === 'rejected'
                                ? true
                                : location?.state?.isView || disabled
                            }
                            onChange={(e) =>
                              setTtdAvailableSlot(
                                moment(e.target.value).format('YYYY-MM-DD')
                              )
                            }
                            excluded={ttdDatesApproved}
                            highlighted={ttdDatesInProgress}
                            errors={errors}
                            defaultValue={getValues(
                              conditionalFields[3].fieldName
                            )}
                          />
                        </>
                      </Grid>
                    )}
                  {privateRequestType === 'Help/Assistance' && (
                    <Grid item xs={12} lg={3}>
                      <>
                        <label className="block text-sm text-gray-800 font-bold pr-4">
                          {conditionalFields[4].fieldTitle}
                        </label>
                        <InputField
                          fieldName={conditionalFields[4].fieldName}
                          validationObj={conditionalFields[4].validationObj}
                          register={register}
                          errors={errors}
                          fieldType={conditionalFields[4].fieldType}
                          onChange={(e) => setOther(e.target.value)}
                          val={getValues(conditionalFields[4].fieldName)}
                          disabled={
                            task?.ticketStatus === 'rejected'
                              ? true
                              : location?.state?.isView || disabled
                          }
                        />
                      </>
                    </Grid>
                  )}
                  {privateRequestType === 'other' && (
                    <Grid item xs={12} lg={3}>
                      <>
                        <label className="block text-sm text-gray-800 font-bold pr-4">
                          {conditionalFields[4].fieldTitle}
                        </label>
                        <InputField
                          fieldName={conditionalFields[4].fieldName}
                          validationObj={conditionalFields[4].validationObj}
                          register={register}
                          errors={errors}
                          fieldType={conditionalFields[4].fieldType}
                          onChange={(e) => setOther(e.target.value)}
                          val={getValues(conditionalFields[4].fieldName)}
                          disabled={
                            task?.ticketStatus === 'rejected'
                              ? true
                              : location?.state?.isView || disabled
                          }
                        />
                      </>
                    </Grid>
                  )}
                  {privateRequestType === 'Employment' &&
                    employmentRequestType === 'other' && (
                      <Grid item xs={12} lg={3}>
                        <>
                          <label className="block text-sm text-gray-800 font-bold pr-4">
                            {conditionalFields[4].fieldTitle}
                          </label>
                          <InputField
                            fieldName={conditionalFields[4].fieldName}
                            validationObj={conditionalFields[4].validationObj}
                            register={register}
                            errors={errors}
                            fieldType={conditionalFields[4].fieldType}
                            onChange={(e) => setOther(e.target.value)}
                            val={getValues(conditionalFields[4].fieldName)}
                            disabled={
                              task?.ticketStatus === 'rejected'
                                ? true
                                : location?.state?.isView || disabled
                            }
                          />
                        </>
                      </Grid>
                    )}
                  {requestType === 'personal' &&
                    personalRequestType === 'other' && (
                      <Grid item xs={12} lg={3}>
                        <>
                          <label className="block text-sm text-gray-800 font-bold  pr-4">
                            {conditionalFields[4].fieldTitle}
                          </label>
                          <InputField
                            fieldName={conditionalFields[4].fieldName}
                            validationObj={conditionalFields[4].validationObj}
                            register={register}
                            errors={errors}
                            fieldType={conditionalFields[4].fieldType}
                            onChange={(e) => setOther(e.target.value)}
                            val={getValues(conditionalFields[4].fieldName)}
                            disabled={
                              task?.ticketStatus === 'rejected'
                                ? true
                                : location?.state?.isView || disabled
                            }
                          />
                        </>
                      </Grid>
                    )}
                  {requestType === 'personal' &&
                    personalRequestType === 'Employment Request' && (
                      <Grid item xs={12} lg={3}>
                        <>
                          <label className="block text-sm text-gray-800 font-bold  pr-4">
                            {conditionalFields[5].fieldTitle}
                          </label>
                          <InputField
                            fieldName={conditionalFields[5].fieldName}
                            validationObj={conditionalFields[5].validationObj}
                            register={register}
                            errors={errors}
                            fieldType={conditionalFields[5].fieldType}
                            onChange={(e) => setQualification(e.target.value)}
                            val={getValues(conditionalFields[5].fieldName)}
                            disabled={
                              task?.ticketStatus === 'rejected'
                                ? true
                                : location?.state?.isView || disabled
                            }
                          />
                        </>
                      </Grid>
                    )}
                  {requestType === 'personal' &&
                    personalRequestType === 'Transfer Request' && (
                      <>
                        <Grid item xs={12} lg={3}>
                          <label className="block text-sm text-gray-800 font-bold  pr-4">
                            {conditionalFields[6].fieldTitle}
                          </label>
                          <SelectDropdown
                            fieldName={
                              requestMode === 'state'
                                ? conditionalFields[1].fieldName
                                : requestMode === 'central'
                                ? conditionalFields[9].fieldName
                                : ''
                            }
                            options={
                              requestMode === 'state'
                                ? conditionalFields[1]?.options
                                : requestMode === 'central'
                                ? conditionalFields[9]?.options
                                : null
                            }
                            register={register}
                            // validationObj={{
                            //   required: 'Please Select Request Type',
                            // }}
                            errors={errors}
                            onChange={(e) => {
                              if (requestMode === 'state') {
                                setStateDepartment(e.target.value);
                                setCentralDepartment('');
                              } else if (requestMode === 'central') {
                                setCentralDepartment(e.target.value);
                                setStateDepartment('');
                              }
                            }}
                            val={
                              requestMode === 'state'
                                ? getValues(conditionalFields[1].fieldName)
                                : requestMode === 'central'
                                ? getValues(conditionalFields[9].fieldName)
                                : ''
                            }
                            disabled={
                              task?.ticketStatus === 'rejected'
                                ? true
                                : location?.state?.isView || disabled
                            }
                          />
                        </Grid>

                        {requestMode === 'state' && (
                          <Grid item xs={12} lg={3}>
                            <label className="block text-sm text-gray-800 font-bold pr-4">
                              {conditionalFields[12].fieldTitle}
                            </label>
                            <SelectDropdown
                              fieldName={conditionalFields[12].fieldName}
                              options={conditionalFields[12].options}
                              register={register}
                              // validationObj={{
                              //   required: 'Please Select Request Type',
                              // }}
                              errors={errors}
                              val={getValues(conditionalFields[12].fieldName)}
                              disabled={
                                task?.ticketStatus === 'rejected'
                                  ? true
                                  : location?.state?.isView || disabled
                              }
                            />
                          </Grid>
                        )}

                        <Grid item xs={12} lg={3}>
                          <label className="block text-sm text-gray-800 font-bold  pr-4">
                            {conditionalFields[7].fieldTitle}
                          </label>
                          <InputField
                            fieldName={conditionalFields[7].fieldName}
                            validationObj={conditionalFields[7].validationObj}
                            register={register}
                            errors={errors}
                            fieldType={conditionalFields[7].fieldType}
                            onChange={(e) => setCurrentLocation(e.target.value)}
                            val={getValues(conditionalFields[7].fieldName)}
                            disabled={
                              task?.ticketStatus === 'rejected'
                                ? true
                                : location?.state?.isView || disabled
                            }
                          />
                        </Grid>

                        <Grid item xs={12} lg={3}>
                          <label className="block text-sm text-gray-800 font-bold  pr-4">
                            {conditionalFields[8].fieldTitle}
                          </label>
                          <InputField
                            fieldName={conditionalFields[8].fieldName}
                            validationObj={conditionalFields[8].validationObj}
                            register={register}
                            errors={errors}
                            fieldType={conditionalFields[8].fieldType}
                            onChange={(e) =>
                              setRequestedLocation(e.target.value)
                            }
                            val={getValues(conditionalFields[8].fieldName)}
                            disabled={
                              task?.ticketStatus === 'rejected'
                                ? true
                                : location?.state?.isView || disabled
                            }
                          />
                        </Grid>

                        <Grid item xs={12} lg={3}>
                          <div className="flex items-center lg:mt-10">
                            <CheckboxField
                              fieldName={conditionalFields[10].fieldName}
                              register={register}
                              validationObj={
                                conditionalFields[10].validationObj
                              }
                              onChange={(checked) => setContactDetails(checked)}
                              errors={errors}
                              disabled={
                                task?.ticketStatus === 'rejected'
                                  ? true
                                  : location?.state?.isView || disabled
                              }
                            />
                            <label className="block text-sm text-gray-800 font-bold  pl-2">
                              {conditionalFields[10].fieldTitle}
                            </label>
                          </div>
                        </Grid>

                        {contactDetails &&
                          transferContactDetails.map((details, index) => (
                            <Grid item xs={12} lg={3} key={index}>
                              <label className="block text-sm text-gray-800 font-bold  pr-4">
                                {details.fieldTitle}
                              </label>
                              <InputField
                                fieldName={details.fieldName}
                                validationObj={{ required: false }}
                                register={register}
                                errors={errors}
                                val={getValues(details.fieldName)}
                                disabled={
                                  task?.ticketStatus === 'rejected'
                                    ? true
                                    : location?.state?.isView || disabled
                                }
                              />
                            </Grid>
                          ))}
                      </>
                    )}
                </>
                <>
                  {requestMode !== 'private' && requestType === 'official' && (
                    <>
                      <Grid item xs={12} lg={3}>
                        <label className="block text-gray-800 text-sm font-bold  pr-4">
                          {conditionalFields[1].fieldTitle}
                        </label>
                        <SelectDropdown
                          fieldName={
                            requestMode === 'state'
                              ? conditionalFields[1].fieldName
                              : conditionalFields[9].fieldName
                          }
                          options={
                            requestMode === 'state'
                              ? conditionalFields[1]?.options
                              : conditionalFields[9].options
                          }
                          register={register}
                          // validationObj={{
                          //   required: 'Please Select Request Type',
                          // }}
                          errors={errors}
                          onChange={(e) => {
                            if (requestMode === 'state') {
                              setStateDepartment(e.target.value);
                              setCentralDepartment('');
                            } else {
                              setCentralDepartment(e.target.value);
                              setStateDepartment('');
                            }
                          }}
                          val={
                            requestMode === 'state'
                              ? getValues(conditionalFields[1].fieldName)
                              : getValues(conditionalFields[9].fieldName)
                          }
                          disabled={
                            task?.ticketStatus === 'rejected'
                              ? true
                              : location?.state?.isView || disabled
                          }
                        />
                      </Grid>
                      {requestMode === 'state' && (
                        <Grid item xs={12} lg={3}>
                          <label className="block text-sm text-gray-800 font-bold pr-4">
                            {conditionalFields[12].fieldTitle}
                          </label>
                          <SelectDropdown
                            fieldName={conditionalFields[12].fieldName}
                            options={conditionalFields[12].options}
                            register={register}
                            // validationObj={{
                            //   required: 'Please Select Request Type',
                            // }}
                            errors={errors}
                            val={getValues(conditionalFields[12].fieldName)}
                            disabled={
                              task?.ticketStatus === 'rejected'
                                ? true
                                : location?.state?.isView || disabled
                            }
                          />
                        </Grid>
                      )}
                    </>
                  )}

                  {requestType === 'official' &&
                    officialContactDetails.map((details) => (
                      <Grid item xs={12} lg={3}>
                        <>
                          <label className="block text-sm text-gray-800 font-bold  pr-4">
                            {details.fieldTitle}
                          </label>
                          <InputField
                            fieldName={details.fieldName}
                            validationObj={details.validationObj}
                            register={register}
                            errors={errors}
                            fieldType={details.fieldType}
                            val={getValues(details.fieldName)}
                            disabled={
                              task?.ticketStatus === 'rejected'
                                ? true
                                : location?.state?.isView || disabled
                            }
                          />
                        </>
                      </Grid>
                    ))}
                </>
                <>
                  {requestMode !== 'private' && requestType === 'community' && (
                    <>
                      <Grid item xs={12} lg={3}>
                        <label className="block text-sm text-gray-800 font-bold  pr-4">
                          {conditionalFields[1].fieldTitle}
                        </label>
                        <SelectDropdown
                          fieldName={
                            requestMode === 'state'
                              ? conditionalFields[1].fieldName
                              : conditionalFields[9].fieldName
                          }
                          options={
                            requestMode === 'state'
                              ? conditionalFields[1]?.options
                              : conditionalFields[9].options
                          }
                          register={register}
                          // validationObj={{
                          //   required: 'Please Select Request Type',
                          // }}
                          errors={errors}
                          onChange={(e) => {
                            if (requestMode === 'state') {
                              setStateDepartment(e.target.value);
                              setCentralDepartment('');
                            } else {
                              setCentralDepartment(e.target.value);
                              setStateDepartment('');
                            }
                          }}
                          val={
                            requestMode === 'state'
                              ? getValues(conditionalFields[1].fieldName)
                              : getValues(conditionalFields[9].fieldName)
                          }
                          disabled={
                            task?.ticketStatus === 'rejected'
                              ? true
                              : location?.state?.isView || disabled
                          }
                        />
                      </Grid>
                      {requestMode === 'state' && (
                        <Grid item xs={12} lg={3}>
                          <label className="block text-sm text-gray-800 font-bold pr-4">
                            {conditionalFields[12].fieldTitle}
                          </label>
                          <SelectDropdown
                            fieldName={conditionalFields[12].fieldName}
                            options={conditionalFields[12].options}
                            register={register}
                            // validationObj={{
                            //   required: 'Please Select Request Type',
                            // }}
                            errors={errors}
                            val={getValues(conditionalFields[12].fieldName)}
                            disabled={
                              task?.ticketStatus === 'rejected'
                                ? true
                                : location?.state?.isView || disabled
                            }
                          />
                        </Grid>
                      )}
                      <Grid item xs={12} lg={3}>
                        <div className="flex items-center lg:mt-10">
                          <CheckboxField
                            fieldName={conditionalFields[11].fieldName}
                            register={register}
                            validationObj={conditionalFields[11].validationObj}
                            onChange={(checked) => setDetailsKnown(checked)}
                            errors={errors}
                            disabled={
                              task?.ticketStatus === 'rejected'
                                ? true
                                : location?.state?.isView || disabled
                            }
                          />
                          <label className="block text-gray-800 text-sm font-bold mb-4 pl-2">
                            {conditionalFields[11].fieldTitle}
                          </label>
                        </div>
                      </Grid>
                    </>
                  )}

                  {requestType === 'community' &&
                    detailsKnown &&
                    communityContactDetails.map((details) => (
                      <Grid item xs={12} lg={3}>
                        <>
                          <label className="block text-sm text-gray-800 font-bold  pr-4">
                            {details.fieldTitle}
                          </label>
                          <InputField
                            fieldName={details.fieldName}
                            validationObj={details.validationObj}
                            register={register}
                            errors={errors}
                            fieldType={details.fieldType}
                            val={getValues(details.fieldName)}
                            disabled={
                              task?.ticketStatus === 'rejected'
                                ? true
                                : location?.state?.isView || disabled
                            }
                          />
                        </>
                      </Grid>
                    ))}
                </>
                <>
                  {requestType === 'medical' && (
                    <>
                      <Grid item xs={12} lg={3}>
                        <label className="block text-sm text-gray-800 font-bold  pr-4">
                          {conditionalFields[2].fieldTitle}
                        </label>
                        <SelectDropdown
                          fieldName={conditionalFields[2].fieldName}
                          options={conditionalFields[2]?.options}
                          register={register}
                          validationObj={{
                            required: 'Please Select Request Type',
                          }}
                          errors={errors}
                          onChange={(e) => {
                            setMedicalRequestType(e.target.value);
                            setPersonalRequestType('');
                          }}
                          val={getValues(conditionalFields[2].fieldName)}
                          disabled={location?.state?.isView}
                        />
                      </Grid>
                      {medicalDetails.map((details) => (
                        <Grid item xs={12} lg={3}>
                          <>
                            <label className="block text-sm text-gray-800 font-bold  pr-4">
                              {details.fieldTitle}
                            </label>
                            <InputField
                              fieldName={details.fieldName}
                              validationObj={details.validationObj}
                              register={register}
                              errors={errors}
                              fieldType={details.fieldType}
                              val={getValues(details.fieldName)}
                              disabled={
                                task?.ticketStatus === 'rejected'
                                  ? true
                                  : location?.state?.isView || disabled
                              }
                            />
                          </>
                        </Grid>
                      ))}
                    </>
                  )}
                </>
                <>
                  {requestType === 'other' && (
                    <>
                      <Grid item xs={12} lg={3}>
                        <>
                          <label className="block text-sm text-gray-800 font-bold  pr-4">
                            {conditionalFields[4].fieldTitle}
                          </label>
                          <InputField
                            fieldName={conditionalFields[4].fieldName}
                            validationObj={conditionalFields[4].validationObj}
                            register={register}
                            errors={errors}
                            fieldType={conditionalFields[4].fieldType}
                            val={getValues(conditionalFields[4].fieldName)}
                            disabled={
                              task?.ticketStatus === 'rejected'
                                ? true
                                : location?.state?.isView || disabled
                            }
                          />
                        </>
                      </Grid>
                    </>
                  )}
                </>
              </>
            )}

            <>
              {isRequestToggle &&
                grievanceRequestFields
                  .filter(
                    (field) => field.fieldName === 'additionalInformation'
                  )
                  .map((field) => {
                    const { fieldTitle, fieldName, fieldType, validationObj } =
                      field;

                    return (
                      <Grid item xs={12} key={fieldName}>
                        <label className="block text-sm text-gray-800 font-bold  pr-4">
                          {fieldTitle}
                        </label>
                        <InputField
                          fieldName={fieldName}
                          validationObj={validationObj}
                          register={register}
                          errors={errors}
                          fieldType={fieldType}
                          val={getValues(fieldName)}
                          disabled={
                            task?.ticketStatus === 'rejected'
                              ? true
                              : location?.state?.isView || disabled
                          }
                        />
                      </Grid>
                    );
                  })}
            </>
          </Grid>

          <Grid container spacing={1}>
            <Grid item xs={12}>
              <div
                className="flex justify-between items-center text-white rounded-md bg-gray-700 p-2 mb-1 cursor-pointer"
                onClick={refferalToggleAccordion} // Toggle on click
              >
                <h2>Referral Details</h2>
                {/* Render the icon based on the toggle state */}
                {isRefferalToggle ? <FaChevronUp /> : <FaChevronDown />}
              </div>
            </Grid>

            {isRefferalToggle &&
              referalFields.map((field) => {
                const {
                  fieldTitle,
                  fieldName,
                  fieldType,
                  validationObj,
                  options,
                } = field;

                return (
                  <Grid item xs={12} key={fieldName} lg={2.4}>
                    <label className="block text-sm text-gray-800 font-bold  pr-4">
                      {fieldTitle}
                    </label>

                    {fieldType === 'select' ? (
                      <SelectDropdown
                        fieldName={fieldName}
                        register={register}
                        options={
                          fieldName === 'referralType'
                            ? referralType
                            : referralMode
                        }
                        onChange={(e) =>
                          fieldName === 'referralType' &&
                          setRefType(e.target.value)
                        }
                        validationObj={validationObj}
                        errors={errors}
                        disabled={
                          task?.ticketStatus === 'rejected'
                            ? true
                            : location?.state?.isView || disabled
                        }
                        val={getValues(
                          fieldName === 'referralType'
                            ? 'referralType'
                            : 'referralMode'
                        )}
                      />
                    ) : fieldName === 'referralContact' ? (
                      <>
                        <PhoneInput
                          className="shadow appearance-none border border-solid border-gray-700 w-full py-2.5 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-blue-500 disabled:bg-gray-200"
                          country="IN"
                          name={fieldName}
                          defaultValue={getValues(fieldName)}
                          control={control}
                          placeholder="Ref Phone Number"
                          onBlur={handleBlur}
                          id={fieldName}
                          rules={{
                            validate: (value) =>
                              isPossiblePhoneNumber(`${value}`),
                          }}
                          disabled={
                            task?.ticketStatus === 'rejected'
                              ? true
                              : location?.state?.isView || disabled
                          }
                        />
                        {errors[fieldName] && (
                          <p className="py-2 text-red-900">
                            Enter Valid Phone Number
                          </p>
                        )}
                      </>
                    ) : (
                      <InputField
                        fieldName={fieldName}
                        validationObj={validationObj}
                        register={register}
                        errors={errors}
                        fieldType={fieldType}
                        disabled={
                          task?.ticketStatus === 'rejected'
                            ? true
                            : location?.state?.isView || disabled
                        }
                        value={getValues(fieldName)}
                      />
                    )}
                  </Grid>
                );
              })}
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <div
                className="flex justify-between items-center text-white rounded-md bg-gray-700 p-2 mb-1 cursor-pointer"
                onClick={assignedToggleAccordion} // Toggle on click
              >
                <h2>For Office Use Only</h2>
                {/* Render the icon based on the toggle state */}
                {isAssignedToggle ? <FaChevronUp /> : <FaChevronDown />}
              </div>
            </Grid>
            {isAssignedToggle &&
              approvalActionFields.map((field) => {
                const {
                  fieldTitle,
                  fieldName,
                  fieldType,
                  validationObj,
                  options,
                } = field;

                return (
                  <Grid item xs={12} key={fieldName} lg={3}>
                    <label className="block text-sm text-gray-800 font-bold pr-4">
                      {fieldTitle}
                    </label>

                    {fieldType === 'select' && fieldName === 'priority' ? (
                      <SelectDropdown
                        fieldName={fieldName}
                        register={register}
                        options={priority}
                        validationObj={validationObj}
                        fieldType={fieldType}
                        errors={errors}
                        disabled={
                          task?.ticketStatus === 'rejected'
                            ? true
                            : location?.state?.isView || disabled
                        }
                      />
                    ) : fieldType === 'date' &&
                      fieldName === 'targetResolution' ? (
                      <>
                        <DateField
                          fieldName={fieldName}
                          validationObj={validationObj}
                          control={control}
                          Controller={Controller}
                          errors={errors}
                          defaultValue={getValues(fieldName)}
                          disabled={
                            task?.ticketStatus === 'rejected'
                              ? true
                              : location?.state?.isView || disabled
                          }
                        />
                      </>
                    ) : fieldType === 'text' && fieldName === 'ccEmail' ? (
                      <>
                        <InputField
                          fieldName={fieldName}
                          validationObj={emailValidation}
                          register={register}
                          errors={errors}
                          fieldType={fieldType}
                          disabled={location?.state?.isView}
                          value={getValues(fieldName)}
                        />
                      </>
                    ) : (
                      <SelectDropdown
                        fieldType={fieldType}
                        fieldName={fieldName}
                        register={register}
                        options={assignedTo}
                        validationObj={validationObj}
                        errors={errors}
                        disabled={
                          task?.ticketStatus === 'rejected'
                            ? true
                            : location?.state?.isView || disabled
                        }
                      />
                    )}
                  </Grid>
                );
              })}
          </Grid>
          <ApplicationTabs
            taskId={id}
            ticketNo={ticketNo}
            isView={
              task?.ticketStatus === 'rejected'
                ? true
                : location?.state?.isView || disabled
            }
            task={task}
          />
          {!location?.state?.isView ? submitBtns() : null}
        </form>
      </div>
    </>
  );
};

export default Form;
